import { Box, HStack, Spinner, Text, useTheme } from '@chakra-ui/react';
import { type ReactElement } from 'react';

export type SavingOverlayProps = {
	message?: string;
};

/** Full-screen grey backdrop that blocks all interaction; optional blue toast-style message. */
export const SavingOverlay = (props: SavingOverlayProps = {}): ReactElement => {
	const { message } = props;
	const theme = useTheme();

	// Use toast z-index to ensure it appears above everything
	const backdropZIndex = theme.z?.toast || 1700;
	const toastZIndex = backdropZIndex + 1;

	return (
		<>
			{/* Semi-transparent grey backdrop to block all interactions */}
			<Box
				position="fixed"
				top={0}
				left={0}
				right={0}
				bottom={0}
				w="100vw"
				h="100vh"
				zIndex={backdropZIndex}
				bg="blackAlpha.500"
				pointerEvents="all"
				cursor="not-allowed"
			/>
			{/* Blue toast-style loading modal at bottom of screen */}
			{message && (
				<Box
					position="fixed"
					bottom={6}
					left="50%"
					transform="translateX(-50%)"
					zIndex={toastZIndex}
					pointerEvents="none"
				>
					<HStack
						bg="blue.500"
						color="white"
						px={6}
						py={4}
						borderRadius="md"
						boxShadow="lg"
						spacing={4}
						minW="280px"
					>
						<Spinner
							size="md"
							color="white"
							thickness="3px"
							speed="0.8s"
						/>
						<Text fontSize="md" fontWeight="medium">
							{message}
						</Text>
					</HStack>
				</Box>
			)}
		</>
	);
};
